export default function AboutDrone() {
  return (
    <section className="about-section">
      <div className="section-content">
        <h2>about drone</h2>
        
        <div className="about-grid">
          <div className="about-card">
            <h3>The Sound</h3>
            <p>
              Drone music is characterized by sustained or repeated notes and sounds,
              creating an immersive sonic landscape. It emphasizes texture over structure,
              inviting listeners to experience sound as a physical presence.
            </p>
          </div>
          
          <div className="about-card">
            <h3>The Approach</h3>
            <p>
              Using analog synthesizers, processed guitars, and field recordings,
              we build layered compositions that evolve slowly over time. Each piece
              is a meditation on resonance and harmonic interplay.
            </p>
          </div>
          
          <div className="about-card">
            <h3>The Experience</h3>
            <p>
              Best experienced through quality headphones or speakers capable of
              reproducing deep frequencies. Allow the sound to envelop you—there's
              no right or wrong way to listen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
